import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const ResourceStore = create((set) => {
    let _ResourceStore = {
        portalResources: [],
        portalResource: null,
        footerPortalResources: null,
        fullTextSearchString: '',
        currentPage: 1,
        pageSize: 9,
        filterSettings: [],
        /*[
			{
				label: "Fach übergreifend",
				isCollapsed: true,
				subAreas: [
					{ label: "Adaptivität", isActive: false, isAvailable:true},
					{ label: "Testen", isActive: false, isAvailable:true},
					{ label: "Scaffolding", isActive: false, isAvailable:true},
					{ label: "Kollaboratives Learen", isActive: false, isAvailable:true},
					{ label: "Ethische Perspektive", isActive: false, isAvailable:true}
				]
			}, 
			{
				label: "Sprachen",
				isCollapsed: true,
				subAreas: [
					{ label: "French", isActive: false, isAvailable:true},
					{ label: "English", isActive: false, isAvailable:true},
					{ label: "Latin", isActive: false, isAvailable:true},
					{ label: "Spanish", isActive: false, isAvailable:false},
				]
			}
		]*/ fileForUpload: null,
        availableImages: null,
        availablePdfs: null,
    };

    _ResourceStore.findByLabel = (labelledObjects, label) => {
        for (let i = 0; i < labelledObjects.length; i++) {
            let labelledObj = labelledObjects[i];

            if (label === labelledObj.label) {
                return labelledObj;
            }
        }

        console.log(
            'Warning: Could not find labelled object for label: ' +
                label +
                ' in object set : \n' +
                JSON.stringify(labelledObjects, null, 2),
        );

        return null;
    };

    _ResourceStore.getUserFriendlyLabel = (areaLabel) => {
        switch (areaLabel) {
            case 'SEARCH_CRIT_RESOURCE_TYPE':
                return 'Materialtyp';
            case 'SEARCH_CRIT_SUBJECT_MATTER_CATEGORY':
                return 'Fach';
            case 'SEARCH_CRIT_MEDIA_USAGE_GOAL':
                return 'Themenschwerpunkt';
            case 'SEARCH_CRIT_SCHOOL_TYPE':
                return 'Bildungssystem';
            default:
                return areaLabel;
        }
    };

    _ResourceStore.search = (
        searchCriteria,
        fullTextSearchString,
        currentPage,
        pageSize,
        successCallback,
        errorCallback,
    ) => {
        let payload = {};

        for (let i = 0; i < searchCriteria.length; i++) {
            let searchCriterion = searchCriteria[i];

            payload[searchCriterion.label] = [];

            for (let j = 0; j < searchCriterion.subAreas.length; j++) {
                let subArea = searchCriterion.subAreas[j];

                if (subArea.isActive) {
                    payload[searchCriterion.label].push(subArea.label);
                }
            }
        }

        // Backend supports f set of keywords to search for, so we need
        // to put the search value into an array
        payload['fullTextSectionSearchString'] = [fullTextSearchString];
        payload['currentPage'] = currentPage;
        payload['pageSize'] = pageSize;

        const url = AppConfig.HOST_URL + 'resource/search';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    return { portalResources: data.results };
                });
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.updateAttribute = (attributeName, newValue) => {
        set((state) => {
            state.portalResource[attributeName] = newValue;
            return { portalResource: state.portalResource };
        });
    };

    _ResourceStore.resetPortalResource = () => {
        set((state) => {
            return { portalResource: {} };
        });
    };

    _ResourceStore.updateSection = (i, heading, text) => {
        set((state) => {
            state.portalResource.sections[i].heading = heading;
            state.portalResource.sections[i].text = text;
            return { portalResource: state.portalResource };
        });
    };

    _ResourceStore.updateSubSection = (i, j, heading, text) => {
        set((state) => {
            state.portalResource.sections[i].subSections[j].heading = heading;
            state.portalResource.sections[i].subSections[j].text = text;

            return { portalResource: state.portalResource };
        });
    };

    _ResourceStore.addSection = (
        portalResourceId,
        newSection,
        successCallback,
        errorCallback,
    ) => {
        const payload = { portalResourceId: portalResourceId, newSection };
        const url = AppConfig.HOST_URL + 'section/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    if (null == state.portalResource.sections) {
                        state.portalResource.sections = [];
                    }

                    state.portalResource.sections.push(data);
                    return { portalResource: state.portalResource };
                });
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.saveSection = (section, successCallback, errorCallback) => {
        const payload = { section };
        const url = AppConfig.HOST_URL + 'section/save';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.deleteSection = (
        sectionId,
        successCallback,
        errorCallback,
    ) => {
        const payload = { sectionId: sectionId };
        const url = AppConfig.HOST_URL + 'section/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.addSubSection = (
        sectionId,
        newSubSection,
        successCallback,
        errorCallback,
    ) => {
        const payload = { sectionId, newSubSection };
        const url = AppConfig.HOST_URL + 'section/addSubSection';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    var targetSectionIndex = -1;
                    for (
                        var i = 0;
                        i < state.portalResource.sections.length;
                        i++
                    ) {
                        if (sectionId == state.portalResource.sections[i].id) {
                            break;
                        }
                    }

                    state.portalResource.sections[targetSectionIndex] = data;

                    return { portalResource: state.portalResource };
                });
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.saveSubSection = (
        subSection,
        successCallback,
        errorCallback,
    ) => {
        const payload = {
            subSectionId: subSection.id,
            subSectionJSON: JSON.stringify(subSection),
        };
        const url = AppConfig.HOST_URL + 'section/updateSubSection';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.deleteSubSection = (
        sectionId,
        subSectionId,
        successCallback,
        errorCallback,
    ) => {
        const payload = { sectionId: sectionId, subSectionId: subSectionId };
        const url = AppConfig.HOST_URL + 'section/deleteSubSection';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    var targetSectionIndex = -1;
                    for (
                        var i = 0;
                        i < state.portalResource.sections.length;
                        i++
                    ) {
                        if (sectionId == state.portalResource.sections[i].id) {
                            break;
                        }
                    }

                    state.portalResource.sections[targetSectionIndex] = data;

                    return { portalResource: state.portalResource };
                });
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.loadAll = (
        pageSize,
        currentPage,
        successCallback,
        errorCallback,
    ) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'resource/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ portalResources: data.results }));
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.loadForFooterTeaser = (successCallback, errorCallback) => {
        const payload = {};
        const url = AppConfig.HOST_URL + 'resource/loadForFooterTeaser';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ footerPortalResources: data }));
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.loadNewestArticlesForFrontPage = (
        successCallback,
        errorCallback,
    ) => {
        const payload = {};
        const url =
            AppConfig.HOST_URL + 'resource/loadNewestArticlesForFrontPage';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ portalResources: data }));
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.resetSearchCriteriaAndRefreshPage = (
        pageSize,
        successCallback,
        errorCallback,
    ) => {
        const payload = {};
        const url = AppConfig.HOST_URL + 'resource/loadSearchOptions';

        let areas = [];

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                for (let i = 0; i < data.areas.length; i++) {
                    if (null != data.areas[i].subAreas) {
                        data.areas[i].isCollapsed = true;
                        data.areas[i].userFriendlyLabel =
                            _ResourceStore.getUserFriendlyLabel(
                                data.areas[i].label,
                            );

                        for (
                            let j = 0;
                            j < data.areas[i].subAreas.length;
                            j++
                        ) {
                            // Is available is not working currently
                            if (
                                null === data.areas[i].subAreas[j].isAvailable
                            ) {
                                data.areas[i].subAreas[j].isAvailable = false;
                            }
                        }

                        areas.push(data.areas[i]);
                    }
                }

                set((state) => ({
                    filterSettings: areas,
                    fullTextSearchString: '',
                    currentPage: 1,
                    pageSize: pageSize,
                }));
            },
            /* Reinitialize the page with default search criteria */ () => {
                _ResourceStore.search(
                    areas,
                    '',
                    1,
                    pageSize,
                    successCallback,
                    errorCallback,
                );
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.load = (id, successCallback, errorCallback) => {
        // Prevent the old portal resource from briefly showing
		set((state) => ({ portalResource: null }));

		const payload = { id: id };
        const url = AppConfig.HOST_URL + 'resource/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ portalResource: data }));
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.create = (data, successCallback, errorCallback) => {
        const payload = data;
        var url = AppConfig.HOST_URL + 'resource/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.save = (data, successCallback, errorCallback) => {
        const payload = data;
        var url = AppConfig.HOST_URL + 'resource/save';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.delete = (id, successCallback, errorCallback) => {
        const payload = { id: id };
        var url = AppConfig.HOST_URL + 'resource/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.loadSearchOptions = (successCallback, errorCallback) => {
        const payload = {};
        const url = AppConfig.HOST_URL + 'resource/loadSearchOptions';

        let areas = [];

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                for (let i = 0; i < data.areas.length; i++) {
                    if (null != data.areas[i].subAreas) {
                        data.areas[i].isCollapsed = true;
                        data.areas[i].userFriendlyLabel =
                            _ResourceStore.getUserFriendlyLabel(
                                data.areas[i].label,
                            );

                        for (
                            let j = 0;
                            j < data.areas[i].subAreas.length;
                            j++
                        ) {
                            // Is available is not working currently
                            if (
                                null === data.areas[i].subAreas[j].isAvailable
                            ) {
                                data.areas[i].subAreas[j].isAvailable = false;
                            }
                        }

                        areas.push(data.areas[i]);
                    }
                }

                set((state) => ({
                    filterSettings: areas,
                    fullTextSearchString: '',
                }));
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.toggleFilterParamSetting = (areaLabel, subAreaLabel) => {
        set((state) => {
            const area = _ResourceStore.findByLabel(
                state.filterSettings,
                areaLabel,
            );
            const subArea = _ResourceStore.findByLabel(
                area.subAreas,
                subAreaLabel,
            );

            subArea.isActive = !subArea.isActive;

            return { filterSettings: state.filterSettings };
        });
    };

    _ResourceStore.toggleAreaCollapsedState = (areaLabel) => {
        set((state) => {
            const area = _ResourceStore.findByLabel(
                state.filterSettings,
                areaLabel,
            );

            area.isCollapsed = !area.isCollapsed;

            return { filterSettings: state.filterSettings };
        });
    };

    _ResourceStore.setFullTextSearchString = (str) => {
        set((state) => {
            return { fullTextSearchString: str };
        });
    };

    _ResourceStore.setFileForUpload = (file) => {
        set((state) => {
            return { fileForUpload: file };
        });
    };

    _ResourceStore.uploadFile = (
        portalResourceId,
        file,
        fileType,
        successCallback,
        errorCallback,
    ) => {
        var formData = new FormData();
        formData.set('file', file);
        formData.set('fileType', fileType);
        formData.set('portalResourceId', portalResourceId.toString());

        const url = AppConfig.HOST_URL + 'fileUpload/uploadFile';

        return BackEndConnection.doAxiosFormDataPost(
            url,
            formData,
            () => {
                set((state) => {
                    return { fileForUpload: null };
                });

                if ('image' == fileType) {
                    _ResourceStore.listAvailableImages(portalResourceId);
                } else {
                    _ResourceStore.listAvailablePdfs(portalResourceId);
                }
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.deleteFile = (
        portalResourceId,
        filename,
        fileType,
        successCallback,
        errorCallback,
    ) => {
        const payload = {
            portalResourceId: portalResourceId,
            filename: filename,
            fileType: fileType,
        };

        const url = AppConfig.HOST_URL + 'fileUpload/deleteFile';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                if ('image' == fileType) {
                    _ResourceStore.listAvailableImages(portalResourceId);
                } else {
                    _ResourceStore.listAvailablePdfs(portalResourceId);
                }
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.listAvailableImages = (
        portalResourceId,
        successCallback,
        errorCallback,
    ) => {
        const payload = { portalResourceId: portalResourceId };
        var url = AppConfig.HOST_URL + 'fileUpload/loadAllImages';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    return { availableImages: data };
                });
            },
            successCallback,
            errorCallback,
        );
    };

    _ResourceStore.listAvailablePdfs = (
        portalResourceId,
        successCallback,
        errorCallback,
    ) => {
        const payload = { portalResourceId: portalResourceId };
        var url = AppConfig.HOST_URL + 'fileUpload/loadAllPdfs';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    return { availablePdfs: data };
                });
            },
            successCallback,
            errorCallback,
        );
    };

    return _ResourceStore;
});

export default ResourceStore;
